import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Bold inline component
 * Inline component for bold text emphasis
 */
const Bold = ({ children, ...props }) => {
  return (
    <Typography
      component="strong"
      sx={{ fontWeight: 'bold', display: 'inline' }}
      {...props}
    >
      {children}
    </Typography>
  );
};

Bold.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Bold;
